import { LegalLayout, LegalSection } from "../component/legal/LegalLayout";
import { siteConfig } from "../config/site";

export function CorporateGovernancePage() {
  return (
    <LegalLayout
      eyebrow="Policies"
      title="Corporate Governance"
      description={`Ensuring transparency, accountability, and ethical leadership at ${siteConfig.companyName}.`}
    >
      <LegalSection heading="Background">
        <p>
          This Corporate Governance Policy provides the framework under
          which the Board of Directors of {siteConfig.companyName} (the
          "Company") operates. It includes the Company's corporate
          structure, culture, policies, and the manner in which it deals
          with various stakeholders.
        </p>
        <p>
          The Policy has been aligned with the Companies Act, 2013, SEBI
          (Listing Obligations and Disclosure Requirements) Regulations,
          2015, and the RBI's Corporate Governance guidelines for NBFCs.
        </p>
      </LegalSection>

      <LegalSection heading="Board of Directors">
        <p>
          The Board is responsible for acting in the best interests of the
          Company and its shareholders. In discharging their duties, the
          Directors shall comply with the Code of Conduct as adopted by the
          Board.
        </p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Optimum combination of executive and non-executive directors.</li>
          <li>At least one independent woman director.</li>
          <li>Not less than 50% non-executive directors.</li>
        </ul>
        <p>
          Provided that where the non-executive chairperson is a promoter
          or related to the promoter/management, at least half the Board
          shall consist of independent directors.
        </p>
      </LegalSection>

      <LegalSection heading="Board Meetings">
        <p>
          Board meetings shall be held at least four times a year, with a
          maximum gap of 120 days between consecutive meetings. The minimum
          statutory information required under SEBI Listing Regulations
          shall be furnished to the Directors.
        </p>
      </LegalSection>

      <LegalSection heading="Committees of the Board">
        <ul className="grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-2 list-disc pl-5">
          <li>Audit Committee</li>
          <li>Nomination & Remuneration Committee</li>
          <li>Stakeholders Relationship Committee</li>
          <li>Risk Management Committee</li>
          <li>Corporate Social Responsibility Committee</li>
          <li>IT Strategy Committee</li>
          <li>Customer Service Committee</li>
          <li>Asset Liability Management Committee (ALCO)</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Vigil Mechanism">
        <p>
          The Company shall formulate a vigil mechanism / whistle blower
          policy to enable directors and employees to report instances of
          unethical behaviour, actual or suspected fraud, or violation of
          the Company's Code of Conduct, without fear of reprisal.
        </p>
      </LegalSection>

      <LegalSection heading="Fit & Proper Criteria">
        <p>
          The Company shall maintain a Board-approved policy for
          determining the fit and proper criteria of directors at the time
          of appointment, and on a continuing basis, in line with
          applicable RBI guidelines for NBFCs.
        </p>
      </LegalSection>

      <LegalSection heading="Disclosure & Transparency">
        <p>The Company shall put up the following to the Board periodically:</p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Progress on risk management systems.</li>
          <li>Conformity with corporate governance standards.</li>
        </ul>
        <p>Annual Financial Statement disclosures shall cover:</p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Regulatory registrations/licences</li>
          <li>Credit ratings and migrations</li>
          <li>Regulatory penalties</li>
          <li>Joint venture details</li>
          <li>Asset-liability maturity and other RBI-mandated disclosures</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Rotation of Statutory Auditors">
        <p>
          Audit partners must be rotated periodically, as per RBI
          guidelines applicable to Non-Banking Financial Companies.
        </p>
      </LegalSection>

      <LegalSection heading="CEO/CFO Certification">
        <p>
          The MD & CEO and CFO shall certify the Company's financial
          statements and internal controls as per applicable SEBI Listing
          Regulations and RBI directions.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
